import React from 'react';
import { LookupListTemplate, LookupSelectTemplate } from 'themes/modules/lookup/pages';
import { setCurrentView } from 'core/utils';
import { LookupViewStore } from 'modules/lookup/stores';
import { observer } from 'mobx-react';

@setCurrentView(rootStore => new LookupViewStore(rootStore), 'lookupViewStore')
@observer
class LookupList extends React.Component {
	constructor(props) {
		super(props);
		const { lookupViewStore } = this.props;
		this.permissions = lookupViewStore.permissions;
		lookupViewStore.setHeaderComponent({ component: LookupSelectTemplate, props: this.props });
	}
	render() {
		const { lookupViewStore } = this.props;
		const { allList, onLookupSelect, initDone, ...otherProps } = lookupViewStore;
		if (!lookupViewStore.selectedLookup) {
			return (
				<section className="layout__main__body">
					<LookupListTemplate
						{...otherProps}
						sortObject={allList.tableData.sortObject}
						onRowClick={onLookupSelect}
						tableData={allList.tableData}
						queryUtility={allList.queryUtility}
						allList={allList}
						viewStore={lookupViewStore}
					/>
				</section>
			);
		} else {
			return (
				<section className="layout__main__body">
					<LookupListTemplate {...this.props} viewStore={lookupViewStore} actions={lookupViewStore} />
				</section>
			);
		}
	}
}

export default LookupList;
